export default __webpack_public_path__ + "static/media/folderEmpty.1b16a9e5.svg";